// extracted by mini-css-extract-plugin
module.exports = {"buttonTransparentPrimary":"ButtonTransparentPrimary_buttonTransparentPrimary__3wcTq"};